import React, { useState } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import AsyncSelect from 'react-select/async';
import toast from 'react-hot-toast';

import { CityService, College } from 'us-web-services';

interface Props {
  college: College;
  setCollege(college: College): void;
}

export default function CollegeEditForm(props: Props) {
  const { college, setCollege } = props;

  const [name, setName] = useState(college.name);
  const [alias, setAlias] = useState(college.alias);
  const [urlAlias, setUrlAlias] = useState(college.urlAlias);
  const [street, setStreet] = useState(college.street);
  const [city, setCity] = useState(college.city);
  const [state, setState] = useState(college.state);
  const [zip, setZip] = useState(college.zip);
  const [latitude, setLatitude] = useState(college.latitude);
  const [longitude, setLongitude] = useState(college.longitude);

  const getCities = async (inputValue: string) => {
    const paramList = new URLSearchParams();

    paramList.append('limit', '25');
    paramList.append('page', '1');

     const trimmed = inputValue.trim();

     if (trimmed) {
       const sanitized = trimmed.replace(/'/g, '');

       paramList.append('q', `name.startsWith('${sanitized}')`);
     }

    try {
      const citiesResponse = await CityService.getByFilter({ params: paramList });
      const citiesData = citiesResponse.data.data ?? [];

      return citiesData.map(cityData => ({
        id: cityData.id,
        name: cityData.name,
        value: cityData.id,
        label: `${cityData.name}, ${cityData.state}`,
        state: cityData.state,
       }),
      );
     } catch (e) {
       toast.error(e?.response?.data?.errors?.[0]?.message ?? 'Failed to load cities');

       return [];
     }
  };

  const updateCityState = selected => {
    if (selected) {
      setCity(selected.name);
      setState(selected.state);
      college.city = selected.name;
      college.state = selected.state;
      setCollege(college);
    }
  };

  const updateName = event => {
    setName(event.target.value);
    college.name = event.target.value;
    setCollege(college);
  };

  const updateAlias = event => {
    setAlias(event.target.value);
    college.alias = event.target.value;
    setCollege(college);
  };

  const updateUrlAlias = event => {
    setUrlAlias(event.target.value);
    college.urlAlias = event.target.value;
    setCollege(college);
  };

  const updateStreet = event => {
    setStreet(event.target.value);
    college.street = event.target.value;
    setCollege(college);
  };

  const updateCity = event => {
    setCity(event.target.value);
    college.city = event.target.value;
    setCollege(college);
  };

  const updateState = event => {
    setState(event.target.value);
    college.state = event.target.value;
    setCollege(college);
  };

  const updateZip = event => {
    setZip(event.target.value);
    college.zip = event.target.value;
    setCollege(college);
  };

  const updateLatitude = event => {
    setLatitude(event.target.value);
    college.latitude = event.target.value;
    setCollege(college);
  };

  const updateLongitude = event => {
    setLongitude(event.target.value);
    college.longitude = event.target.value;
    setCollege(college);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          id='name'
          name='name'
          label='Name'
          fullWidth
          value={name}
          onChange={updateName}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id='alias'
          name='alias'
          label='Alias'
          fullWidth
          value={alias}
          onChange={updateAlias}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id='urlAlias'
          name='urlAlias'
          label='URL Alias'
          fullWidth
          value={urlAlias}
          onChange={updateUrlAlias}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id='street'
          name='street'
          label='Street'
          fullWidth
          value={street}
          onChange={updateStreet}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='subtitle1' color='textPrimary'>
          City and State
        </Typography>
        <AsyncSelect
          id='citystate'
          loadOptions={getCities}
          defaultOptions
          defaultInputValue={city && state ? `${city}, ${state}` : ''}
          onChange={updateCityState}
          placeholder='Search for a city...'
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='city'
          name='city'
          label='City'
          fullWidth
          value={city}
          onChange={updateCity}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='state'
          name='state'
          label='State'
          fullWidth
          value={state}
          onChange={updateState}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id='zip'
          name='zip'
          label='Zip'
          fullWidth
          value={zip}
          onChange={updateZip}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id='latitude'
          name='latitude'
          label='Latitude'
          fullWidth
          value={latitude}
          onChange={updateLatitude}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          id='longitude'
          name='longitude'
          label='Longitude'
          fullWidth
          value={longitude}
          onChange={updateLongitude}
        />
      </Grid>
    </Grid>
  );
}
